import React from 'react';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Blocks from 'scratch-blocks';
import classnames from 'classnames';

import { connect } from 'react-redux';

import FeedbackLoading from './feedback-loading.jsx';
import Feedbackquestion from './feedback-question.jsx';

import { closeFeedBack } from '../../reducers/modals';
import { setHelpData } from '../../reducers/targets';

import styles from './feedback-page.css';

import closeIcon from '../menu-bar/icon--close.svg';
import correct from './correct.svg';
import error from './error.svg';

import bindAll from 'lodash.bindall';


const messages = defineMessages({
    name: {
        id: 'gui.feedback.name',
        description: 'Your name',
        defaultMessage: 'Your name'
    },
    phone: {
        id: 'gui.feedback.phone',
        description: 'Your contact number',
        defaultMessage: 'Your contact number'
    },
    content: {
        id: 'gui.feedback.content',
        description: 'Your comments/feedback',
        defaultMessage: 'Your comments/feedback'
    }
});

class Feedback extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            fileMessage: '',
            testingName: 2,
            testingPhone: 2,
            testingOpinion: 2,
            lang: 'en',
            data: [],
            loading: false,
            feedloading: true,
            controller: null
        }
        //this.getdata = this.getData.bind(this)
        bindAll(this, [
            'fileload',
            'closeFeedBackPage',
            'handleGetdata',
            'verifyName',
            'verifyPhone',
            'verifyOpinion',
            'clearValueData',
            'clearFile',
            'handCloseloading'
        ]);
    }
    componentDidMount() {

    }
    fileload(e) {
        if (this.filedata.files[0] != undefined) {
            this.setState({
                fileMessage: this.filedata.files[0].name
            })
        }

    }
    closeFeedBackPage() {
        this.props.close()
    }
    handleGetdata() {

        //名字、号码、反馈内容如果其中一项为空，则不提交
        if (this.state.testingName == false || this.state.testingName == 2 ||
            this.state.testingPhone == false || this.state.testingPhone == 2 ||
            this.state.testingOpinion == false || this.state.testingOpinion == 2) {

            if (this.state.testingName == false || this.state.testingName == 2) {
                this.setState({
                    testingName: false
                })
            }
            if (this.state.testingPhone == false || this.state.testingPhone == 2) {
                this.setState({
                    testingPhone: false
                })
            }
            if (this.state.testingOpinion == false || this.state.testingOpinion == 2) {
                this.setState({
                    testingOpinion: false
                })
            }
            return
        }

        //判断文件大小不能超过8M
        if (document.querySelector("input[name='message']").files[0]) {
            var fileSize = document.querySelector("input[name='message']").files[0].size
            if (fileSize >= (8 * 1024 * 1024)) {
                Blocks.customAlert('prompt', "上传文件大小不能超过8M")
                return
            }
        }


        var formdate = document.getElementsByClassName('feedback-page_from-icon_wP7VN')[0]
        // const url = 'http://ccws.fun/test/test.php';
        const url = 'https://edu.zmrobo.com/scratchHelp/submitForm.php';
        //  const url = 'http://localhost/test/submitForm.php';
        var fordates = new FormData(formdate)
        var controller = new AbortController()
        this.setState({
            controller: controller,
            feedloading: false
        })
        let signal = controller.signal
        // react fetch实现跨域post请求,需要修改apach服务器的httpd.conf文件，添加Header set Access-Control-Allow-Origin *
        fetch(url, {
            method: 'POST',
            headers: {},
            body: fordates,
            signal: signal
        }).then((response) => {
            return response.text();
        }).then((json) => {
            if (json == '1') {
                this.setState({
                    feedloading: true
                })
                this.props.setupdateProgress(9);
                this.props.setStateTrue('isUpdateBox');
                this.clearValueData();
            }
        }).catch((error) => {
            console.error(error);
        });

        // jsonp实现跨域get请求
        // $.ajax({
        //     url:"http://wx.zmrobo.com/runScratch3/test.php",  
        //     dataType:'jsonp',  
        //     data:'',  
        //     jsonp:'callback',  
        //     success:function(result) {  
        //         for(var i in result) {  
        //             console.log(i+":"+result[i]);//循环输出a:1,b:2,etc.  
        //         }  
        //     },  
        //     timeout:3000
        // });
    }

    //名字验证
    verifyName(e) {
        let dom = e.target.value;
        let nameexp = /^[\u4e00-\u9fa5\sA-Za-z0-9]{2,20}$/ig
        let nameexp2 = /^\s/ig
        let hasValue = JSON.stringify(nameexp.test(dom))
        let hasValue2 = JSON.stringify(nameexp2.test(dom))
        if (dom != " " && hasValue === "true" && hasValue2 != "true") {
            setTimeout(() => {
                this.setState({
                    testingName: true
                })
            }, 0)
        } else {
            setTimeout(() => {
                this.setState({
                    testingName: false
                })
            }, 0)
        }

    }
    //号码验证
    verifyPhone(e) {
        let dom = e.target.value;
        let nameexp = /^1[345678]\d{9}$|^((\d{3,4}-)|\d{3.4}-)?\d{7,8}$/ig
        let hasValue = JSON.stringify(nameexp.test(dom))
        if (dom != " " && hasValue === "true") {
            setTimeout(() => {
                this.setState({
                    testingPhone: true
                })
            }, 0)
        } else {
            setTimeout(() => {
                this.setState({
                    testingPhone: false
                })
            }, 0)
        }
    }
    //反馈内容不能为空
    verifyOpinion(e) {
        if (e.target.value == "") {
            setTimeout(() => {
                this.setState({
                    testingOpinion: false
                })
            }, 0)
        } else {
            setTimeout(() => {
                this.setState({
                    testingOpinion: true
                })
            }, 0)
        }
    }
    //清空表单数据
    clearValueData() {
        document.querySelector("input[name='name']").value = null;
        document.querySelector("input[name='phoneName").value = null;
        document.querySelector("textarea[name='opinion']").value = null;
        document.querySelector("input[name='message']").value = null;
        this.setState({
            testingName: 2,
            testingPhone: 2,
            testingOpinion: 2,
            fileMessage: ''
        })
    }
    clearFile() {
        document.querySelector("input[name='message']").value = null
        setTimeout(() => {
            this.setState({
                fileMessage: ''
            })
        }, 0)
    }
    handCloseloading() {
        this.state.controller.abort()
        this.setState({
            feedloading: true
        })
    }

    render() {
        const {
            intl,
            isFullScreen,
            setupdateProgress,
            setStateTrue,
            setStateFalse
        } = this.props

        const testingNameStyles = this.state.testingName || this.state.testingName == 2 ? null : { borderColor: 'red' }
        const phoneStyles = this.state.testingPhone || this.state.testingPhone == 2 ? null : { borderColor: 'red' }
        const textareaStyles = this.state.testingOpinion || this.state.testingOpinion == 2 ? null : { borderColor: 'red' }
        const fileStyle = this.state.fileMessage != '' ? { borderColor: 'rgb(83, 209, 114)' } : null
        return (
            <div className={styles.feedback}>
                <div className={styles.fromBox}>
                    <div className={styles.fromTab}>
                        <div>
                            <div className={styles.fromTitle}>
                                <span>
                                    <FormattedMessage
                                        defaultMessage="Ask for help"
                                        description="Ask for help"
                                        id="gui.feedback.helpTitle"
                                    />
                                </span>
                                <div
                                    className={styles.closeBox}
                                    onClick={this.closeFeedBackPage}
                                >
                                    <img
                                        className={styles.closeIcon}
                                        src={closeIcon}
                                        draggable="false" />
                                </div>
                            </div>
                            <div className={styles.fromContent}>
                                <form
                                    className={classnames(styles.fromIcon)}
                                    action=""
                                    method="POST"
                                    encType="multipart/form-data"
                                >
                                    <div className={styles.fromOne}>
                                        <input type="text" placeholder={intl.formatMessage(messages.name)} onBlur={this.verifyName} name="name" style={testingNameStyles} />
                                        {this.state.testingName == 2 ? null : this.state.testingName ?
                                            (<img className={classnames(styles.tipsIcon)} src={correct} draggable="false" alt="" />) :
                                            (<img className={classnames(styles.tipsIcon)} src={error} draggable="false" alt="" />)}
                                        {this.state.testingName || this.state.testingName == 2 ? null : (<div className={styles.opinionError}>{Blocks.Msg["gui.feedback.errorPrompt1"]}</div>)}
                                    </div>

                                    <div className={styles.fromTwo}>
                                        <input type="text" placeholder={intl.formatMessage(messages.phone)} onBlur={this.verifyPhone} name="phoneName" style={phoneStyles} />
                                        {this.state.testingPhone == 2 ? null : this.state.testingPhone ?
                                            (<img className={classnames(styles.tipsIcon)} src={correct} draggable="false" alt="" />) :
                                            (<img className={classnames(styles.tipsIcon)} src={error} draggable="false" alt="" />)}
                                        {this.state.testingPhone || this.state.testingPhone == 2 ? null : (<div className={styles.opinionError}>{Blocks.Msg["gui.feedback.errorPrompt2"]}</div>)}
                                    </div>

                                    <div className={styles.fromThree}>
                                        <textarea id='memo' placeholder={intl.formatMessage(messages.content)} name="opinion" onBlur={this.verifyOpinion} style={textareaStyles}></textarea>
                                        {this.state.testingOpinion == 2 ? null : this.state.testingOpinion ? null : (<img className={classnames(styles.tipsIcon)} src={error} draggable="false" alt="" />)}
                                        {this.state.testingOpinion || this.state.testingOpinion == 2 ? null : (<div className={styles.opinionError}>{Blocks.Msg["gui.feedback.errorPrompt3"]}</div>)}
                                    </div>

                                    <div className={styles.fromFile} style={fileStyle}>
                                        {this.state.fileMessage != '' ?
                                            (<div className={styles.fileMessage}>
                                                <div>{this.state.fileMessage}</div>
                                                <span onClick={this.clearFile}>X</span>
                                            </div>) : (<label htmlFor="file">
                                                <FormattedMessage
                                                    defaultMessage="Click Upload Attachment"
                                                    description="Click Upload Attachment"
                                                    id="gui.feedback.upload"
                                                />
                                            </label>)}

                                        <input id="file" ref={files => this.filedata = files} type="file" name="message" onChange={this.fileload} style={{ 'display': 'none' }} />

                                    </div>

                                    <div className={styles.fromBtn}>
                                        <button type="button" onClick={this.handleGetdata}>
                                            <FormattedMessage
                                                defaultMessage="Submit"
                                                description="Submission"
                                                id="gui.feedback.submit"
                                            />
                                        </button>
                                    </div>

                                </form>
                                {/* {this.state.loading ? (<div className={styles.loading2}>
                                    <FeedbackLoading />
                                </div>) : ( */}
                                <div className={styles.problem}>
                                    <Feedbackquestion className={styles} />
                                </div>
                                {/* )} */}
                            </div>
                        </div>
                    </div>

                    {/* 上传加载动画及取消上传按钮 */}
                    <div className={classnames(styles.feedloadingBox, { [styles.feedshowloading]: this.state.feedloading })}>
                        <div className={styles.loadingSmallBox}>

                            <div className={styles.lineSpinFadeLoader}>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div className={styles.loadingTitle} onClick={this.handCloseloading}>
                                取消
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
const mapStateToProps = state => ({
    // This is the button's mode, as opposed to the actual current state
    isfeedback: state.scratchGui.modals.isfeedback,
    helpData: state.scratchGui.targets.helpData
});

const mapDispatchToProps = (dispatch, props) => ({
    close: () => dispatch(closeFeedBack()),
    setHelpData: (data) => dispatch(setHelpData(data))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Feedback);